__turbopack_context__.v({
  "deliveryInfoList": "DeliveryInfoList-module-scss-module__QFopNW__deliveryInfoList",
});
